// extracted by mini-css-extract-plugin
module.exports = {"product-support-manuals":"Manuals_product-support-manuals__pdK26"};